var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 74,
    height: 74,
    rx: 16,
    fill: "#FF5A1F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3917_24916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 38,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 15.6582H58.1696V40.3587H21.0547V15.6582Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3917_24916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1974 33.8001C23.1359 33.8001 22.0872 33.7422 21.0547 33.6311V40.2012C22.0941 40.2915 23.1417 40.3367 24.1974 40.3367C29.0185 40.3367 33.6972 39.391 38.1039 37.525C42.359 35.7239 46.1788 33.145 49.4592 29.8622C52.7385 26.5783 55.314 22.7538 57.114 18.4953C57.5075 17.5612 57.8606 16.6155 58.1731 15.6582H51.2106C46.8398 26.2936 36.378 33.8001 24.1974 33.8001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3917_24916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 7,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 15.623H27.4234V37.5107H21.0547V15.623Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3917_24916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.886 37.2102C25.0319 37.1627 26.1895 37.0551 27.3401 36.9092V15.6582H21.0547V37.2276C21.9981 37.2461 22.9426 37.2496 23.886 37.2102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3917_24916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 33,
    width: 38,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 33.7344H58.1696V58.4788H21.0547V33.7344Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3917_24916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1974 40.3373C23.1359 40.3373 22.0872 40.3952 21.0547 40.5063V33.9362C22.0941 33.8459 23.1417 33.8008 24.1974 33.8008C29.0185 33.8008 33.6972 34.7465 38.1039 36.6124C42.359 38.4135 46.1788 40.9925 49.4592 44.2752C52.7385 47.5591 55.314 51.3836 57.114 55.6433C57.5075 56.5763 57.8606 57.522 58.1731 58.4792H51.2106C46.8398 47.8439 36.378 40.3373 24.1974 40.3373Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3917_24916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 46,
    width: 7,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 46.8203H27.3447V58.4789H21.0547V46.8203Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3917_24916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1974 46.875C23.1359 46.875 22.0872 46.9329 21.0547 47.044V58.4792H27.3401V47.044C26.3064 46.934 25.2588 46.875 24.1974 46.875Z",
    fill: "#292131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.609bf1ea519b3f8eae693308555887a1.svg";
export { ForwardRef as ReactComponent };